export default {
    auth: {
        nonIntegratedIdentity: null,
        integratedIdentity: null,
    },

    eventId: null,
    currentTeamId: null,
    event: null,
    isBadEvent: false,
    hasStartedRostering: false,
    rosterValidated: false,
    roles: [],

    me: { // @TODO: Check impact of change from null to empty object amongst allreferences
        id: null,
        organization: {
            id: null,
            name: null,
            gender: null,
            athletes: [],
            teams: [],
            sport: null,
        },
    },
    
    roster: [],
    rosterErrors: [],
    duplicateEmails: [],
    rosterErrorCount: 0,
    requiredErrorCount:0,
    coaches: [{}],

    accountRetrieval: null,
    loginSubmission: null,
    registrationSubmission: null,
    hadSubmissionError: false,

    steps: [
        {
            'label': 1,
            'title': 'Introduction',
            'route': 'Roster/Event/TeamWelcome',
            'canGoBackwards': true,
            'dependsOn': [],
        },
        {
            'label': 2,
            'title': 'Contact Info/Login',
            'route': (state) => state.auth.integratedIdentity ? `Roster/Event/Auth/Login` : `Roster/Event/Auth/Register`,
            'canGoBackwards': true,
            'dependsOn': ['hasStartedRostering'],
        },
        {
            'label': 3,
            'title': 'Add Athletes',
            'route': (state) => state.auth.integratedIdentity ? `Roster/Event/RosterAthletes/Integrated` : `Roster/Event/RosterAthletes/Manual`,
            'canGoBackwards': true,
            'dependsOn': ['auth', ((state) => state.auth.integratedIdentity ? `integratedIdentity` : `nonIntegratedIdentity`)],
        },
        {
            'label': 4,
            'title': 'Add Coaches',
            'route': 'Roster/Event/RosterCoaches',
            'canGoBackwards': true,
            'dependsOn': ['rosterValidated'],
        },
        {
            'label': 5,
            'title': 'Final Review',
            'route': 'Roster/Event/FinalReview',
            'canGoBackwards': true,
            'dependsOn': ['rosterValidated'],
        },
        {
            'label': 6,
            'title': 'Success',
            'route': 'Roster/Event/Success',
            'canGoBackwards': false,
            'dependsOn': ['submitted'],
        },
    ],
    activeStep: 0,

}
